import React from "react";
// import "antd/dist/antd.css";
import { Button } from "antd";
import { Icon } from "@ant-design/icons";
import Widget from "components/widget/Widget";
import { ArrowUpOutlined } from "@ant-design/icons";
import totalorders from "../../../assets/img/servicetype/totalorders.png";
import upcomingorders from "../../../assets/img/servicetype/upcomingorders.svg";
import readytodeliver from "../../../assets/img/servicetype/readytodeliver.svg";
import inprogressorders from "../../../assets/img/servicetype/inprogressorders.png";
import RevenuTable from "components/Tables/Dashboared/RevenuTable";
import { Row, Col } from "antd";
import { FaCheckDouble, FaUser } from "react-icons/fa";

import {
  MdAddShoppingCart,
  MdPendingActions,
  MdPanoramaPhotosphere,
  MdFreeCancellation,
} from "react-icons/md";
const appName = process.env.REACT_APP_APPLICATION_NAME === "store_provider";
console.log(appName, "appName");
const Dashboard = () => {
  const cardData = [
    {
      title: "Total orders",
      number: "50",
      image: totalorders,
    },
    {
      title: "Upcoming orders",
      number: "20",
      image: upcomingorders,
    },
    {
      title: "Ready to deliver orders",
      number: "20",
      image: readytodeliver,
    },
    {
      title: "In-progress orders",
      number: "10",
      image: inprogressorders,
    },
  ];
  React.useEffect(() => {
    const data = localStorage.getItem("userData");
    console.log(data, "iamdatadfadsfad");
  }, []);
  return (
    <div className="ml-2">
      <div className="my-4">Dashboard</div>
      <div className="main"></div>
      <section>
        <div className="container">
          <div className="row">
            <div className="flex gap-[30px]">
              {cardData?.map((card, index) => (
                <Widget
                  key={index}
                  title={card.title}
                  number={card.number}
                  img={card.image}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="mt-5 ">
        <Row gutter={[16, 16]}>
          <Col lg={12} xs={12}>
            <RevenuTable />
          </Col>

          <Col lg={12} xs={12}>
            <Row
              gutter={[16, 16]}
              className="rounded-[20px] bg-white bg-clip-border p-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none"
            >
              <Col lg={12} xs={12} className="mb-3">
                <FaUser style={{ fontSize: "1.5rem", color: "#a968ff" }} />
                <div>
                  <h3 className="text-dark m-0">615</h3>
                  <span className="txt-1">Users</span>
                </div>
              </Col>
              <Col lg={12} xs={12} className="mb-3">
                <MdAddShoppingCart
                  style={{ fontSize: "1.5rem", color: "#40e5d4" }}
                />
                <div>
                  <h3 className="text-dark m-0">10</h3>
                  <span className="txt-1">Orders</span>
                </div>
              </Col>
              <Col lg={12} xs={12} className="mb-3">
                <MdPendingActions
                  style={{ fontSize: "1.5rem", color: "#ff6b99" }}
                />
                <div>
                  <h3 className="text-dark m-0">39</h3>
                  <span className="txt-1">Pending</span>
                </div>
              </Col>
              <Col lg={12} xs={12} className="mb-3">
                <MdPanoramaPhotosphere
                  style={{ fontSize: "1.5rem", color: "#fec107" }}
                />
                <div>
                  <h3 className="text-dark m-0">10</h3>
                  <span className="txt-1">On progress</span>
                </div>
              </Col>
              <Col lg={12} xs={12} className="mb-3">
                <FaCheckDouble
                  style={{ fontSize: "1.5rem", color: "#1ec9ff" }}
                />
                <div>
                  <h3 className="text-dark m-0">53</h3>
                  <span className="txt-1">Delivered</span>
                </div>
              </Col>
              <Col lg={12} xs={12}>
                <MdFreeCancellation
                  style={{ fontSize: "1.5rem", color: "#fc4c5e" }}
                />
                <div>
                  <h3 className="text-dark m-0">4</h3>
                  <span className="txt-1">Cancel_Order</span>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default Dashboard;
